import { type Component, Show } from 'solid-js';
import { createQuery } from '@tanstack/solid-query';
import { settingsApi } from '~/shared/api/settings-api';
import { useToast } from '~/shared/ui/Toast';

export const ClubJoinCodeBadge: Component = () => {
  const toast = useToast();

  const query = createQuery(() => ({
    meta: { peripheral: true },
    queryKey: ['settings', 'club', 'join-code', 'issued'],
    queryFn: ({ signal }) => settingsApi.getIssuedClubJoinCode({ signal }),
    staleTime: Number.POSITIVE_INFINITY,
    retry: false,
  }));

  const copy = async (code: string) => {
    try {
      await navigator.clipboard.writeText(code);
      toast.success('Номер клуба скопирован');
    } catch {
      toast.error('Не удалось скопировать — номер есть в разделе «Привлечение клиентов»');
    }
  };

  return (
    <Show when={query.data?.code}>
      {(code) => (
        <button
          type="button"
          class="press hidden xl:flex items-center gap-1.5 h-9 px-2.5 rounded-md hover:bg-white/6"
          title="Номер клуба — нажмите, чтобы скопировать"
          aria-label={`Номер клуба ${code()}, скопировать`}
          onClick={() => void copy(code())}
        >
          <span class="text-[10px] uppercase tracking-wider text-tertiary">Клуб</span>
          <span class="font-mono text-[13px] tracking-[0.08em] text-secondary">{code()}</span>
        </button>
      )}
    </Show>
  );
};
